import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FinishInstantPayAutoAdvanceRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FinishInstantPayAutoAdvanceResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const finishInstantPayAutoAdvance = (
  request: FinishInstantPayAutoAdvanceRequest,
  options?: CashRequestOptions
) =>
  post<FinishInstantPayAutoAdvanceRequest, FinishInstantPayAutoAdvanceResponse>(
    '/2.0/cash/finish-instant-pay-auto-advance',
    request,
    { ...options, rejectOnError: true }
  )
